import { render, staticRenderFns } from "./СonstructionProgressPage.vue?vue&type=template&id=8ea9c754&"
import script from "./СonstructionProgressPage.vue?vue&type=script&lang=ts&"
export * from "./СonstructionProgressPage.vue?vue&type=script&lang=ts&"
import style0 from "./СonstructionProgressPage.vue?vue&type=style&index=0&id=8ea9c754&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports